import { render, staticRenderFns } from "./AdminSuperProgramsTable.vue?vue&type=template&id=1b4e76e7&scoped=true&lang=pug&"
import script from "./AdminSuperProgramsTable.vue?vue&type=script&lang=js&"
export * from "./AdminSuperProgramsTable.vue?vue&type=script&lang=js&"
import style0 from "./AdminSuperProgramsTable.vue?vue&type=style&index=0&id=1b4e76e7&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b4e76e7",
  null
  
)

export default component.exports